<template>

  <hmenu></hmenu>

  <main> 
      <section class="ns-banner-area-6">
          <div class="ns-banner-single-6">
              <img src="/assets/img/banner/banner-shape-61.png" alt="" class="ns-banner-shape-61 d-none d-xxl-block">
              <img src="/assets/img/banner/shape-1.png" alt="" class="ns-banner-shape-62 d-none d-sm-block">
              <img src="/assets/img/banner/shape-1.png" alt="" class="ns-banner-shape-63 d-none d-sm-block">
              <div class="container">
                  <div class="row align-items-center">
                      <div class="col-xl-7">
                          <div class="ns-banner-content">
                              <h2 class="ns-banner-content-title">
                                  Kontroll i Plotë. <br> Automatizim i <span>Mençur.</span>
                              </h2>
                              <p>Automatizojmë parkimin, kontrollin e aksesit dhe operacionet tuaja – thjeshtë dhe pa komplikime.</p>
                              <div class="ns-banner-action-btn">
                                <router-link :to="{ name: 'contact' }" class="ns-btn-white ns-theme-btn">Kontakt <i class="fal fa-arrow-right"></i></router-link>
                              </div>
                          </div>
                      </div>
                      <div class="col-xl-5 d-none d-xl-block">
                          <div class="ns-banner-img-6">
                              <img src="/asetet/home_12.png" alt="">
                          </div>
                      </div>
                  </div>
              </div>
          </div>
      </section>



      <section id="services" class="ns-service-area-6 p-relative pt-95 pb-100">
          <img src="/assets/img/service/service-bg-6.png" alt="" class="ns-service-bg-6">
          <div class="container" style="max-width: 1500px;">
              <div class="row mobile_1">
                  <div class="col-12">
                      <div class="ns-section mb-50 text-center">
                          <span class="ns-section-subtitle">Zgjidhjet tona</span>
                          <h2 class="ns-section-title ns-section-title-white mb-0">Teknologji që thjeshton operacionet dhe rrit kontrollin.</h2>
                      </div>
                  </div>
              </div>

             <div class="row ">
                  <div class="col-xl-3 col-lg-3 col-md-6">
                    <router-link :to="{ name: 'parkingServices' }">
                      <div class="ns-service-item-5 ns-service-item-6">
                          <div class="ns-service-item-img-5 w_img">
                              <img src="/asetet/parking.png" alt="">
                          </div>
                          <div class="ns-service-item-content-5">
                              <div class="ns-service-item-content-top-5">
                                  <div class="ns-service-item-icon-5">
                                      <i class="icofont-barricade"></i>
                                  </div>
                                  <h4 class="ns-service-item-content-title-5">Sisteme Parkimi</h4>
                              </div>
                              <p>Menaxhim i automatizuar i <br>hyrje-daljeve dhe pagesave</p>
                          </div>
                            <div class="ns-service-item-hover-6 bg-default" style="background-image: url('/asetet/service-61.png');">
                              <div class="ns-service-item-icon-5">
                                  <i class="icofont-barricade"></i>
                              </div>
                              <h4 class="ns-service-item-content-title-5">
                                Sisteme Parkimi
                              </h4>
                              <p>Zgjidhje të automatizuara për menaxhimin e hyrjeve, daljeve dhe pagesave në parking. Kontroll i plotë dhe efikasitet maksimal pa nevojë për staf të shumtë.</p>
                              <span class="ns-service-count-5 ns-service-count-6">01</span>
                          </div>
                      </div>
                    </router-link>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-6">
                    <router-link :to="{ name: 'sensor' }">
                      <div class="ns-service-item-5 ns-service-item-6">
                          <div class="ns-service-item-img-5 w_img">
                              <img src="/asetet/sensor.png" alt="">
                          </div>
                          <div class="ns-service-item-content-5">
                              <div class="ns-service-item-content-top-5">
                                  <div class="ns-service-item-icon-5">
                                      <i class="icofont-bars"></i>
                                  </div>
                                  <h4 class="ns-service-item-content-title-5">Sistem udhëzimi</h4>
                              </div>
                              <p>Sistem për orientimin <br> e parkimit.</p>
                          </div>
                          <div class="ns-service-item-hover-6 bg-default" style="background-image: url('/asetet/service-61.png');">
                              <div class="ns-service-item-icon-5">
                                  <i class="icofont-bars"></i>
                              </div>
                              <h4 class="ns-service-item-content-title-5">Sistem udhëzimi</h4>
                              <p>Sistem i udhëzimit të parkimit që ndihmon drejtuesit e automjeteve të gjejnë shpejt dhe lehtë vendet e lira të parkimit.</p>
                              <span class="ns-service-count-5 ns-service-count-6">04</span>
                          </div>
                      </div>
                    </router-link>
                  </div>

                  <div class="col-xl-3 col-lg-3 col-md-6">
                    <router-link :to="{ name: 'accessControll' }">
                      <div class="ns-service-item-5 ns-service-item-6">
                          <div class="ns-service-item-img-5 w_img">
                              <img src="/asetet/accesscontroll.png" alt="">
                          </div>
                          <div class="ns-service-item-content-5">
                              <div class="ns-service-item-content-top-5">
                                  <div class="ns-service-item-icon-5">
                                      <i class="icofont-key"></i>
                                  </div>
                                  <h4 class="ns-service-item-content-title-5">Kontroll Aksesi</h4>
                              </div>
                              <p>Kontroll i sigurt i hyrjeve<br> për ndërtesa dhe ambiente.</p>
                          </div>
                          <div class="ns-service-item-hover-6 bg-default" style="background-image: url('/asetet/service-61.png');">
                              <div class="ns-service-item-icon-5">
                                  <i class="icofont-key"></i>
                              </div>
                              <h4 class="ns-service-item-content-title-5">Kontroll Aksesi</h4>
                              <p>Sisteme të avancuara për kontrollin e hyrjeve në ndërtesa, ashensorë dhe zona të kufizuara. Siguri e lartë dhe menaxhim i lehtë për çdo lloj objekti.</p>
                              <span class="ns-service-count-5 ns-service-count-6">02</span>
                          </div>
                      </div>
                    </router-link>
                  </div>
                  <div class="col-xl-3 col-lg-3 col-md-6">
                    <router-link :to="{ name: 'fitness' }">
                      <div class="ns-service-item-5 ns-service-item-6">
                          <div class="ns-service-item-img-5 w_img">
                              <img src="/asetet/fintes.png" alt="">
                          </div>
                          <div class="ns-service-item-content-5">
                              <div class="ns-service-item-content-top-5">
                                  <div class="ns-service-item-icon-5">
                                      <i class="icofont-life-ring"></i>
                                  </div>
                                  <h4 class="ns-service-item-content-title-5">Pishina & Fitness</h4>
                              </div>
                              <p>Menaxhim i hyrjeve dhe <br>anëtarësimeve pa staf shtesë.</p>
                          </div>
                          <div class="ns-service-item-hover-6 bg-default" style="background-image: url('/asetet/service-61.png');">
                              <div class="ns-service-item-icon-5">
                                  <i class="icofont-life-ring"></i>
                              </div>
                              <h4 class="ns-service-item-content-title-5">Pishina & Fitness</h4>
                              <p>Menaxhim inteligjent i hyrjeve dhe anëtarësimeve për pishina dhe qendra fitnesi. Identifikim i shpejtë me karta, QR ose metoda të tjera moderne.</p>
                              <span class="ns-service-count-5 ns-service-count-6">03</span>
                          </div>
                      </div>
                    </router-link>
                  </div>

              </div>
          </div>
      </section>




      <section class="ns-about-area-6 p-relative pt-100 pb-60">
          <img src="/assets/img/about/about-shape-51.png" alt="" class="ns-about-shape-52">
          <div class="container">
              <div class="row">
                  <div class="col-xl-6 col-lg-6">
                      <div class="ns-about-5-img mb-40 mr-25">
                          <div class="ns-about-inner-img-wrap-5 w_img">
                              <img src="/asetet/img1.png" alt="">
                          </div>
                          <div class="ns-about-content-info-5 bg-default d-none d-sm-block" data-background="assets/img/about/about-content-bg-2.png">
                              <div class="ns-about-content-info-top-5">
                                  <div class="ns-about-content-info-counter-5">
                                      <h5 class="ns-about-count-5">
                                          <span class="odometer about_count" data-count="15">00</span><span class="ns-about-plus">+</span>
                                      </h5>
                                  </div>
                                  <div class="ns-about-content-info-icon-5">
                                      <img src="/assets/img/about/headphones-2.png" alt="">
                                  </div>
                              </div>
                              <h5 class="ns-about-content-info-text-5">Eksperienc</h5>
                          </div>
                      </div>
                  </div>
                  <div class="col-xl-6 col-lg-6">
                      <div class="ns-about-wrap-5 mb-40">
                          <div class="ns-section mb-45">
                              <h2 class="ns-section-title ns-section-title-white mb-15">Zgjidhje të besueshme të ndërtuara për performancë dhe thjeshtësi në përdorim. </h2>
                          </div>
                     
                          <div class="ns-management-content mb-50">
                              <ul>
                                  <li>
                                      <span class="ns-management-content-icon"><i class="icofont-check"></i></span>
                                      <div class="ns-management-content-info">
                                          <h5>Zgjidhje të personalizuara.</h5>
                                          <p>Çdo projekt përshtatet sipas nevojave <br>specifike të klientit dhe biznesit tuaj.</p>
                                      </div>
                                  </li>
                                  <li>
                                      <span class="ns-management-content-icon"><i class="icofont-check"></i></span>
                                      <div class="ns-management-content-info">
                                          <h5>Automatizim i plotë.</h5>
                                          <p>Reduktoni kostot dhe eliminoni proceset <br>manuale me sisteme inteligjente.</p>
                                      </div>
                                  </li>
                                  <li>
                                      <span class="ns-management-content-icon"><i class="icofont-check"></i></span>
                                      <div class="ns-management-content-info">
                                          <h5>Integrim i avancuar.</h5>
                                          <p>Sistemet tona lidhen lehtësisht me <br>teknologjitë dhe pajisjet ekzistuese.</p>
                                      </div>
                                  </li> <li>
                                      <span class="ns-management-content-icon"><i class="icofont-check"></i></span>
                                      <div class="ns-management-content-info">
                                          <h5>Mbështetje teknike.</h5>
                                          <p>Ofrojmë suport të vazhdueshëm për funksionim <br>të qëndrueshëm dhe pa ndërprerje.</p>
                                      </div>
                                  </li>
                              </ul>
                          </div>
                      </div>

                  </div>
              </div>
          </div>
      </section>



      <section class="ns-project-area-6 pt-95">
          <div class="container">
              <div class="row">
                  <div class="col-12">
                      <div class="ns-section mb-50 text-center mobile_2">
                          <h2 class="ns-section-title ns-section-title-white mb-0">Ngjarjet e fundit</h2>
                      </div>
                  </div>
              </div>
              <div class="row">
                  <div v-for="blog in blogs" class="col-xl-4 col-lg-6 col-md-6">
                      <div class="ns-blog-item mb-30">
                          <div class="ns-blog-img w_img">
                              <router-link :to="{ name: 'blogDetails', params: { slug: blog.slug }  }">
                                <img :src="'/asetet/projects/'+blog.cover_image">
                              </router-link>
                              <span class="ns-blog-tag">{{blog.category}}</span>
                              <span class="ns-blog-img-shape-1"></span>
                              <span class="ns-blog-img-shape-2"></span>
                          </div>
                          <div class="ns-blog-content">
                              <h3 class="ns-blog-content-title">
                                <router-link :to="{ name: 'blogDetails', params: { slug: blog.slug }  }">
                                  <span v-html="blog.title"></span>
                                </router-link>
                              </h3>
                              <router-link :to="{ name: 'blogDetails', params: { slug: blog.slug }  }">
                                Shiko më shumë<i class="icofont-plus"></i>
                              </router-link>
                              <span class="ns-blog-shape-1"></span>
                              <span class="ns-blog-shape-2"></span>
                          </div>
                      </div>
                  </div>
                 
              </div>
          </div>
      </section>


  </main>

  <Footer></Footer>


</template>

<script>
    import hmenu from './header.vue'
    import Footer from './Footer.vue'

    import blogService from "@/api/blogService";

    export default {


      data(){

        return {

          blogs: []

        }
      },


      components: {
        hmenu,
        Footer,
        blogService,
      },



      methods:{

        async loadBlogs(){
            try {
              let response = await blogService.getBlogs3();
              this.blogs = response.data.data;
            }catch(error){
              console.log(error);
            }

        }

      },



      mounted:function(){
        this.loadBlogs();
      },


  

    }

</script>

